import { gql } from "@apollo/client";

export const GET_USER_ACTIVITY_HISTORY = gql`
  query GetUserActivityHistory(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserActivityHistory(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventName
        message
        createdAt
      }
      nextToken
    }
  }
`;

export const GET_USER_BY_REFERRAL_CODE = gql`
  query GetUserByReferralCode($referralCode: String!) {
    getUserByReferralCode(referralCode: $referralCode) {
      items {
        id
        username
        userType
      }
    }
  }
`;

export const GET_PERFECT_FIT_JOBS_FOR_USER = gql`
  query ListPerfectFitJobsForUser($userId: ID) {
    listPerfectFitJobsForUser(userId: $userId) {
      items {
        jobOpportunity {
          id
          jobLength
          freelancerPitchPrefill
          jobLengthInWeeks
          maxRate {
            value
            currency
          }
          minRate {
            value
            currency
          }
          maxTalentRate {
            value
            currency
          }
          minTalentRate {
            value
            currency
          }
          maxSalary {
            value
            currency
          }
          minSalary {
            value
            currency
          }
          maxTalentSalary {
            value
            currency
          }
          minTalentSalary {
            value
            currency
          }
          optionalTKSkills {
            id
            category
            languageIsoCode
            name
          }
          intelSkills {
            id
            category
            languageIsoCode
            name
          }
          overview
          regions
          geographicalRegions {
            regionName
          }
          location {
            countryName
            cityName
            stateName
          }
          requirements
          responsibilities
          startDate
          startDate
          status
          timeOverlap
          timeCommitment
          timezone {
            label
            value
          }
          title
          TKSkills {
            id
            category
            languageIsoCode
            name
          }
          visibilityLevel
          createdAt
          metadata
          workMode
        }
        perfectJobFitDetails
      }
    }
  }
`;

export const GET_ASSESSMENT_REPORT_LINK = gql`
  query GetAssessmentReportLink($interviewId: String!, $userId: String) {
    getAssessmentReportLink(interviewId: $interviewId, userId: $userId)
  }
`;
